import Vue from 'vue'
import VueRouter from 'vue-router'
import TokenService from '../services/storage.service'
import Code from '../views/Code.vue'
import Login from '../views/Login.vue'

import Customers from  '../views/Customer/Listing.vue'
import Customer from  '../views/Customer/Single.vue'
import NewCustomer from '../views/Customer/New.vue'

import Users from  '../views/Users.vue'
import User from '../views/User.vue'
import NewUser from '../views/NewUser.vue'

import Jobs from '../views/Jobs/Listing.vue'
import JobMain from  '../views/Jobs/Main.vue'
import JobActivities from '../views/Jobs/ActivityLog.vue'
import JobWarranty from '../views/Jobs/Warranty.vue'
import JobIssues from '../views/Jobs/IssueTracker.vue'
import JobEquipment from '../views/Jobs/Equipment.vue'
import JobPunchlist from '../views/Jobs/Punchlist.vue'
import JobPhaseList from '../views/Jobs/PhaseList.vue'
import JobChat from '../views/Jobs/Chat.vue'
import JobImages from '../views/Jobs/Images.vue' 
import JobAssignees from '../views/Jobs/Assignees.vue' 
import JobDetails from '../views/Jobs/JobDetails.vue'
import NewJob from '../views/Jobs/New.vue'

import Calendar from '../views/Calendar.vue'

import Leads from  '../views/Leads.vue'
import Lead from  '../views/Lead.vue'

import ManagePhases from '../views/ManagePhases.vue'

import Teams from '../views/Teams/Listing.vue'
import TeamCalendar from '../views/Teams/Jobs.vue'
import TeamHistory from '../views/Teams/History.vue'
import Settings from '../views/Settings/Settings.vue'

import IssuesTracker from '../views/IssuesTracker.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Login,
    meta: {
      public: true,  // Allow access to guest user.
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Jobs,
    meta: {
      public: false,  // Allow access to only loggedin user.
      api: 'vendor/job/all?page=',
      title: 'Jobs',
      key: 'all'
    }
  },
  {
    path: '/newcustomer',
    name: 'New Customer',
    component: NewCustomer,
    meta: {
      title: 'Create a Customer',
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/customer/:id',
    name: 'Customer',
    component: Customer,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/customers/get',
      title: 'Edit Customer',
      key: 'customer'
    }
  },
  {
    path: '/customers',
    name: 'Customers',
    component: Customers,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/customers/all?page=',
      title: 'All Customers',
      key: 'all'
    }
  },
  {
    path: '/newuser',
    name: 'New User',
    props: true,
    component: NewUser,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/users/all?page=',
      title: 'All Users',
      key: 'all'
    }
  },
  {
    path: '/user/:id',
    name: 'User',
    component: User,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/users/get',
      title: 'User',
      key: 'user'
    }
  },
  {
    path: '/code',
    name: 'Code',
    component: Code,
    meta: {
      public: true,  // Allow access to guest user.
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/teams',
    name: 'Teams',
    component: Teams,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      title: 'Teams',
      key: 'teams'
    }
  },
  {
    path: '/team_calendar/:id',
    name: 'Team Calendar',
    props: true,
    component: TeamCalendar,
    meta: {
      public: false,  // Allow access to only loggedin user.
      api: 'vendor/team/calendar?id=',
    }
  },
  {
    path: '/team_history',
    name: 'Team History',
    props: true,
    component: TeamHistory,
    meta: {
      public: false,  // Allow access to only loggedin user.
      api: 'vendor/team/daily?date=',
    }
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: Jobs,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/job/all?page=',
      title: 'Jobs',
      key: 'all'
    }
  },
  {
    path: '/job/main/:id',
    name: 'JobMain',
    component: JobMain,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/job/get',
      title: 'Job',
      key: 'job_main'
    }
  },
  {
    path: '/job/activities/:id',
    name: 'JobActivities',
    component: JobActivities,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/job/activities',
      title: 'Activities',
      key: 'job_activities'
    }
  },
  {
    path: '/job/warranty/:id',
    name: 'JobWarranty',
    component: JobWarranty,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/job/warranties',
      title: 'Warranty',
      key: 'job_warranties'
    }
  },
  {
    path: '/job/equipment/:id',
    name: 'JobEquipment',
    component: JobEquipment,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/job/equipment',
      title: 'Equipment',
      key: 'job_equipment'
    }
  },
  {
    path: '/job/issue_tracker/:id',
    name: 'JobIssues',
    component: JobIssues,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/job/issues',
      title: 'Issues',
      key: 'job_issues'
    }
  },
  {
    path: '/job/punch_list/:id',
    name: 'JobPunchlist',
    component: JobPunchlist,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/job/punchlist',
      title: 'Punchlist',
      key: 'job_punchlist'
    }
  },
  {
    path: '/job/phase_list/:id',
    name: 'JobPhaseList',
    component: JobPhaseList,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      title: 'Phase List',
      key: 'job_phaselist'
    }
  },
  {
    path: '/job/chat/:id',
    name: 'JobChat',
    component: JobChat,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/job/comments',
      title: 'Chat',
      key: 'job_chat'
    }
  },
  {
    path: '/job/media/:id',
    name: 'JobImages',
    component: JobImages,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/job/images',
      title: 'Images',
      key: 'job_images'
    }
  },
  {
    path: '/job/assignees/:id',
    name: 'JobAssignees',
    component: JobAssignees,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/job/assignees',
      title: 'Assignees',
      key: 'job_assignees'
    }
  },
  {
    path: '/job/details/:id',
    name: 'JobDetails',
    component: JobDetails,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/job/get',
      title: 'Job Details',
      key: 'job_details'
    }
  },
  {
    path: '/newjob',
    name: 'New Job',
    props: true,
    component: NewJob,
    meta: {
      title: 'Create a Job',
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/calendar',
    name: 'Calendar',
    props: true,
    component: Calendar,
    meta: {
      public: false,  // Allow access to only loggedin user.
      api: 'vendor/calendar',
    }
  },
  {
    path: '/phases',
    name: 'Phases',
    props: true,
    component: ManagePhases,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/lead/:id',
    name: 'Lead',
    component: Lead,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/leads/get',
      title: 'Lead',
      key: 'lead'
    }
  },
  {
    path: '/leads',
    name: 'Leads',
    component: Leads,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'vendor/leads/all?page=',
      title: 'All Leads',
      key: 'all'
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      title: 'Settings',
      key: 'settings'
    }
  },
  {
    path: '/issues_tracker',
    name: 'Issues Tracker',
    component: IssuesTracker,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      title: 'Issues Tracker',
      key: 'issues_tracker'
    }
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken();

  if (!isPublic && !loggedIn) {
    return next({
      path:'/',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/dashboard')
  }
  next();
}) 

export default router